export enum CurrencyTypes {
	USD = 'USD',
	COP = 'COP',
	MXN = 'MXN',
	BRL = 'BRL',
}
